'use client';

import Link from 'next/link';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { useSession } from '@/lib/auth-client';
import { geistMonoFont } from '@/_style/fonts';
import { Button } from '@/_components/UIComponents/Button';
import { ArrowRight } from 'lucide-react';
import BetaBadge from '@/_components/BetaBadge/BetaBadge';
import ThemeToggle from '@/_components/ThemeToggle/ThemeToggle';
import ConversationNavbarTitle from '@/_components/AppNavbar/ConversationNavbarTitle.client';
import ConversationNavbarMenu from '@/_components/AppNavbar/ConversationNavbarMenu.client';

export default function LandingNav() {
	const { data: session, isPending } = useSession();
	const pathname = usePathname();
	const isConversationPage = /^\/share\/conversation\//.test(pathname);

	return (
		<header className='border-border/50 flex h-14 flex-shrink-0 items-center gap-2 border-b px-3 sm:px-10 lg:px-20'>
			{/* Left section - Logo + conversation title */}
			<div className='flex min-w-0 flex-1 items-center gap-2'>
				<Link
					href='/'
					className='flex shrink-0 items-center gap-1.5 sm:gap-2'
				>
					<Image
						src='/logo.svg'
						alt='Blockpedia'
						width={28}
						height={28}
						priority
						style={{ filter: 'var(--logo-filter)' }}
					/>
					<span className={`${geistMonoFont.className} text-foreground text-sm font-medium`}>blockpedia</span>
					<span className='hidden sm:inline-flex'>
						<BetaBadge />
					</span>
				</Link>
				<ConversationNavbarTitle />
			</div>

			{/* Right section - Conversation actions + theme + auth */}
			<div className='flex shrink-0 items-center gap-1.5 sm:gap-3'>
				<ConversationNavbarMenu />
				{!isConversationPage && (
					<div className='hidden items-center gap-3 sm:flex'>
						<Link
							href='/discover'
							className='text-muted-foreground hover:text-foreground text-sm'
						>
							Discover
						</Link>
						<Link
							href='/about'
							className='text-muted-foreground hover:text-foreground text-sm'
						>
							About
						</Link>
					</div>
				)}
				<ThemeToggle />
				{!isPending && session ? (
					<Button
						asChild
						size='sm'
						className='bg-pink-600 text-white hover:bg-pink-500'
					>
						<Link href='/new'>
							<span className='ßinline'>Go To App</span>
							<ArrowRight className='ml-1.5 h-3.5 w-3.5' />
						</Link>
					</Button>
				) : (
					<>
						<Button
							asChild
							variant='ghost'
							size='sm'
						>
							<Link href='/login'>Login</Link>
						</Button>
						<Button
							asChild
							size='sm'
							className='hidden bg-pink-600 text-white hover:bg-pink-500 sm:inline-flex'
						>
							<Link href='/signup'>Sign up</Link>
						</Button>
					</>
				)}
			</div>
		</header>
	);
}
